





































































import {
  Component,
  Prop,
  Vue,
  Watch,
  InjectReactive,
  Mixins
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { channelAttrImages } from "@root/lib/mixins";
import skuEditMultiLang from "@/components/pages/ProductCreate/skuEditMultiLang.vue";
import channelAttrItem from "@/components/pages/ProductCreate/channelComponents/channelAttrItem.vue";
import channelSkuMediaDialog from "@/components/pages/ProductCreate/channelComponents/channelSkuMediaDialog.vue";
const Root = namespace("root");
const productCreate = namespace("productCreate");

@Component({
  components: { skuEditMultiLang, channelAttrItem, channelSkuMediaDialog }
})
export default class channelEditSkuDialog extends Mixins(channelAttrImages) {
  @Prop({ default: () => {} }) editData;
  @Prop({ default: () => {} }) rules;
  @Prop({ default: () => [] }) blockList;
  @Prop({ default: () => [] }) channelLanguages;
  @productCreate.Action saveConnSkuList;
  @Root.State permission;
  visible: boolean = false;
  loading: boolean = false;
  ruleForm = {};
  // curNode = {};
  // curEditValue: any = [];

  @Watch("visible")
  onvisibleChange(val, oldVal) {
    let $form: any = this.$refs.editSkuForm;
    if (val) {
      $form && $form.resetFields();
      $form && $form.clearValidate();
      this.ruleForm = JSON.parse(JSON.stringify(this.editData));
    } else {
      // $form && $form.resetFields();
    }
  }

  handleOk() {
    const $form: any = this.$refs.editSkuForm;
    console.log(this.ruleForm, 88, this.rules);

    $form.validate(valid => {
      if (valid) {
        this.$emit("editSkuConfirm", JSON.parse(JSON.stringify(this.ruleForm)));
      }
    });
  }

  // 判断单个属性是否多语言
  itemIsMultiLang(node) {
    return node.languages && node.languages.length > 0;
  }
  // 多语言属性在ruleForm 里的多语言对象key 值
  getMultiKey(node) {
    return this.itemIsMultiLang(node)
      ? `${node.channelAttrCode}Locale`
      : node.channelAttrCode;
  }
  // 多语言属性在ruleForm 里的prop 路径值
  getMultiProp(node) {
    return this.itemIsMultiLang(node)
      ? this.getMultiKey(node)
      : node.channelAttrCode;
  }
  // 编辑图片
  // editImages(value, node) {
  //   this.curNode = node;
  //   this.curEditValue = value;
  //   (this.$refs.channelSkuMediaDialog as any).visible = true;
  // }
  // saveChannelImages(list) {
  //   this.ruleForm[this.getMultiKey(this.curNode)] = list;
  //   this.curNode = {};
  //   this.curEditValue = [];
  // }
}
